import React, { FC, useState, useContext } from "react";
import injectSheet from "react-jss";

import styleSheet from "./styles";
import ArrowIcon from "Assets/ui/sideBarArrow.svg";
interface Props {
  classes: any;
  className?: string;
  fill?: string;
  style?: any;
  wrapperClass?: string;
}
const arrow: FC<Props> = ({
  classes,
  style,
  className,
  fill = "#085FE5", //Default
  wrapperClass
}) => (
  <div className={wrapperClass} style={style}>
    <ArrowIcon className={className} fill={fill} />
  </div>
);

export const Arrow = injectSheet(styleSheet)(arrow);
